<script lang="ts">
    
    import { navigate } from "svelte-navigator";
    import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Icon } from "sveltestrap";
    import { authorizationService } from "../Services";
    import StandardNav from "./StandardNav.svelte";

    let openSidebar = localStorage.getItem('openSidebar') === '1';

    function toggleSidebar() {
        openSidebar = !openSidebar;
        localStorage.setItem('openSidebar', openSidebar ? '1' : '0');
    }

    function onLogOut() {
        if (!confirm('¿Seguro que deseas salir?')) {
            return;
        }
        authorizationService.clearToken();
        navigate('/');
    }

</script>

<div class="app-wrapper">
    <div class="sidebar" class:open={openSidebar}>

        <div class="app-logo">
            <img src="/images/game-name.png" alt="BinFun">
        </div>

        <slot name="sidebar">
            <StandardNav />
        </slot>
    </div>
    <div class="content">
        <div class="topbar">
            <Button type="button" color="light" on:click={toggleSidebar}>
                <Icon name={openSidebar ? 'chevron-left' : 'chevron-right'} />
            </Button>
            <Dropdown>
                <DropdownToggle color="light">
                    <Icon name="three-dots-vertical" />
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem on:click={onLogOut}><Icon name="power" /> Salir</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <slot />
    </div>
</div>

<style lang="scss">

    $app-logo-height: 54px;
    $transitions-duration: 0.5s;

    .app-wrapper {
        display: flex;
        width: 100vw;
        height: 100vh;
    }

    .sidebar {
        width: 50px;
        transition: width $transitions-duration;
        background-color: var(--bs-primary);
        color: #fff;

        &.open {
            width: 200px;

            .app-logo {

                img {
                    width: calc(100% - 20px);
                    height: calc(100% - 20px);
                }

            }
        }
    }

    .app-logo {
        height: $app-logo-height;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            transition-property: width, height;
            transition-duration: $transitions-duration;
            width: calc(100% - 10px);
            height: calc(100% - 10px);
            object-fit: contain;
        }
    }

    .topbar {
        display: flex;
        justify-content: space-between;
        height: $app-logo-height;
        box-sizing: border-box;
        margin: 0 -1rem 1rem;
        padding: 0.5rem;
        background-color: var(--bs-primary);
        color: #fff;
    }

    .content {
        flex: 1 1 0;
        padding: 0 1rem 1rem;
        overflow: auto;
    }

</style>
